//This is just a concept.   Need to code the error properties in DataService

import { Component, Input } from '@angular/core';
import { AppService } from '@Core/services/proprietary/app.service';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppConfigService } from '../../../../../core/services/proprietary/app-config.service';
import { DataSourceStatus } from '../../../../../core/services/proprietary/datasource';

@Component({
    standalone: false,
    selector: 'dataservice-error',
    template: `
    <unity-alert
      type="danger"
      style="margin-bottom: 0 !important;"
      *ngIf="ds.hideErrorControl == false && ds.errorCount != 0"
    >
      <span>One or more data requests failed.</span>
      <div style="position: absolute; right: 1rem">
        <button unity-button
          class="float-end"
          classes="icon-only icon-only-xlarge"
          type="button"
          (click)="clearErrors()"
          ngbTooltip="Close"
        >
          <svg class="unity-icon unity-icon-times" style="fill: var(--unity-primitive-color-red-s10);">
            <use xlink:href="#unity-icon-times"></use>
          </svg>
        </button>
        <button unity-button
          class="float-end"
          classes="icon-only icon-only-xlarge"
          type="button"
          ngbTooltip="Close"
          (click)="model.showDetails = !model.showDetails; model.showDebugInfo = false"
          style="margin-left:8px;margin-right:8px;"
        >
          <svg
            [class]="'unity-icon ' + (model.showDetails ? 'unity-icon-chevron-up' : 'unity-icon-chevron-down')"
            style="fill: var(--unity-primitive-color-red-s10);"
          >
            <use attr.xlink:href="#{{ model.showDetails ? 'unity-icon-chevron-up' : 'unity-icon-chevron-down' }}"></use>
          </svg>
        </button>
        <button unity-button
          class="float-end"
          classes="icon-only icon-only-xlarge"
          type="button"
          ngbTooltip="Show Debug Data"
          *ngIf="model.showDetails && appConfig.allowClientDebug"
          (click)="model.showDebugInfo = !model.showDebugInfo"
          style="margin-left:8px;margin-right:8px; color: var(--unity-primitive-color-red-s10);"
        >
          <i class="fa fa-ep-bug" style="color: var(--unity-primitive-color-red-s10);"></i>
        </button>
      </div>
    </unity-alert>
    <unity-alert type="danger" [noIcon]="true" *ngIf="model.showDetails">
      <div *ngFor="let source of ds.source">
        <div style="margin-bottom:10px" *ngIf="source.status == 'Error'">
          {{ source._replyMessage }} {{ getLastErrorMessage(source) }} ({{ source._replyCode }},
          {{ source._objectType }})
          <div *ngIf="model.showDebugInfo && appConfig.allowClientDebug">
            <div>
              <hr style="margin-left:20px" />
              <div style="margin-left:20px"><b>Request URL:</b> {{ source.lastRequestUrl }}</div>
              <hr style="margin-left:20px" />
              <div style="margin-left:20px" *ngFor="let err of getErrorMessages(source.data)">
                <b>{{ err.node }}</b
                >: {{ err.message }}
              </div>
              <hr style="margin-left:20px" />
              <div style="margin-left:20px">{{ source.data | json }}</div>
              <hr style="margin-left:20px" />
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showPageLevelErrors">
        <div *ngFor="let source of app.pageLevelDataService.source">
          <div style="margin-bottom:10px" *ngIf="source.status == 'Error'">
            {{ source._replyMessage }} {{ getLastErrorMessage(source) }} ({{ source._replyCode }},
            {{ source._objectType }})
            <div *ngIf="model.showDebugInfo && appConfig.allowClientDebug">
              <div>
                <hr style="margin-left:20px" />
                <div style="margin-left:20px"><b>Request URL:</b> {{ source.lastRequestUrl }}</div>
                <hr style="margin-left:20px" />
                <div style="margin-left:20px" *ngFor="let err of getErrorMessages(source.data)">
                  <b>{{ err.node }}</b
                  >: {{ err.message }}
                </div>
                <hr style="margin-left:20px" />
                <div style="margin-left:20px">{{ source.data | json }}</div>
                <hr style="margin-left:20px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </unity-alert>
  `
})
export class DataServiceErrorComponent {
    @Input()
    showPageLevelErrors: boolean = false;

    model = {
        showDetails: false,
        showDebugInfo: false
    };

    constructor(public ds: DataService, public app: AppService, public appConfig: AppConfigService) { }

    clearErrors() {
        this.ds.source.forEach((datasource) => {
            if (datasource._status == DataSourceStatus.Error) {
                datasource.setStatus(DataSourceStatus.Initialized);
            }
        });
    }

    getErrorMessages(data: any): any {
        return this.searchForErr(data);
    }

    getLastErrorMessage(source: any): any {
        let errors: any[] = this.searchForErr(source.data);
        let message = '';
        if (errors && errors.length > 1) {
            let lastMessage: string = errors[errors.length - 1].message;
            let tranMessage: string = source._replyMessage;
            if (lastMessage.trim() != source._replyMessage.trim()) {
                message = lastMessage;
            }
        }
        return message;
    }

    searchForErr(obj: any) {
        let p: any;
        let result: any = [];

        for (p in obj) {
            // iterate on every property

            if (obj[p] == null) {
                continue;
            }

            //if individual element then skip
            if (!(obj[p] instanceof Array || typeof obj[p] == 'object' || obj[p] instanceof Object)) {
                continue;
            }

            //if this node has an error then add error to return array
            if (obj[p].Process_Status == 'ERR') {
                result.push({ node: p, message: obj[p].Process_Message });
            }

            //check child nodes for errors
            result = result.concat(this.searchForErr(obj[p]));
        }

        return result;
    }
}
